const LOCALE_PREFIX_PATTERN = /^\/(bg|en|mk)(?=\/|$|\?|#)/

function getDomainDefaultLocale (hostname: string) {
  return hostname.endsWith('.mk') ? 'mk' : 'bg'
}

function getRouteLocale (path: string) {
  return path.match(LOCALE_PREFIX_PATTERN)?.[1]
}

function getSupportedLocale (hostname: string, path: string) {
  const domainDefaultLocale = getDomainDefaultLocale(hostname)
  const routeLocale = getRouteLocale(path)

  if (routeLocale === 'en' || routeLocale === domainDefaultLocale) {
    return routeLocale
  }

  return domainDefaultLocale
}

function removeLocalePrefix (fullPath: string) {
  const path = fullPath.replace(LOCALE_PREFIX_PATTERN, '')

  if (!path || path.startsWith('?') || path.startsWith('#')) {
    return `/${path}`
  }

  return path
}

export default function ({ app, route, redirect }: any) {
  if (process.client) {
    const newLocale = getSupportedLocale(window.location.hostname, route.path)

    if (app.i18n.locale !== newLocale) {
      app.i18n.setLocale(newLocale)
    }

    document.cookie = `i18n_redirected=${newLocale};path=/`

    const localizedRoute = app.localePath(removeLocalePrefix(route.fullPath), newLocale)
    if (route.fullPath !== localizedRoute) {
      redirect(localizedRoute)
    }
  }
}
